import React, { useEffect, useState, Fragment } from 'react';
import { Row, Col, message, Typography, notification } from 'antd';
import ListCard from 'Molecules/ListCard';
import HeadingChip from 'Molecules/HeadingChip';
import { useDispatch, useSelector } from 'react-redux';
import { getVoucherItems } from '../../../../../ducks/actions'
import { removeVoucherItem, importVoucherItems } from '../../../../../ducks/services'
import { LoadingOutlined } from '@ant-design/icons';
import Search from './Search'
import ActionButton from 'Molecules/ActionButton';
import { useTranslate } from 'Translate';

const _ = require('lodash');

const antIcon = <LoadingOutlined spin />;
const { Title } = Typography;

export default (props) => {
  const dispatch = useDispatch();
  const { id, activeTab, allowedDelete, data } = props;
  const voucherItems = useSelector((state) => state.pos.voucherItems);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(25);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [searchVal, setSearchVal] = useState();
  const [loading, setLoading] = useState(false);
  const i18n = useTranslate();
  const { t } = i18n;

  const colName = [
    {
      title: t("General.code"),
      dataIndex: 'code',
      key: 'code',
      sorter: true,
      render: (text, record) => <h3 className='mb-0'>{text}</h3>
    },
    {
      title: t("Outlet.outlet"),
      dataIndex: 'location_code',
      key: 'location_code',
      sorter: true,
      render: (text) => <span>{text || "-"}</span>
    },
    {
      title: t("General.used_by"),
      dataIndex: 'used_by_name',
      key: 'used_by_name',
      sorter: true,
      render: (text) => <span>{text || "-"}</span>
    },
    {
      title: t("General.used_at"),
      dataIndex: 'used_at',
      key: 'used_at',
      sorter: true,
      render: (text) => <span>{text || "-"}</span>
    },
    {
      title: t("General.status"),
      dataIndex: 'status',
      key: 'status',
      sorter: true,
      render: (text, record) =>
        <div className='flex align-items-center'>
          <span className={(text === "Active" || text === "Used") ? "c-success" : "c-danger"}>
            {t(`General.${text?.toLowerCase()}`)}
          </span>
        </div>
    },
    {
      title: '',
      dataIndex: 'action',
      key: 'action',
      align: 'center',
      render: (text, record) =>
        <ActionButton
          title="voucher_item"
          recordId={record.id}
          onRemove={(record?.status === "Active" && allowedDelete) && onRemove}
          setLoading={setLoading}
          loading={loading}
        />
    }
  ];

  useEffect(() => {
    if (activeTab === "2")
      dispatch(getVoucherItems(1, limit, '', '', null, props.setLoading, id));
  }, [activeTab]);
  
  const handleUpload = async (e) => {
    props.setLoading(true);
    try {
      let res = await importVoucherItems(data?.id, e.file.originFileObj);
      if (res === undefined) return;
      if (res?.res === false) {
        notification.error({ message: res?.msg, duration: 0, placement: 'top', style: { fontSize: "xx-large", width: "450px" } });
      } else {
        if (res?.data?.code === 200) {
          message.success(t("Success.imported_successfully"));
          dispatch(getVoucherItems(1, limit, '', '', null, props.setLoading, id));
        } else {
          notification.error({ message: res?.data?.message, duration: 0, placement: 'top', style: { fontSize: "xx-large", width: "600px" } });
        }
      }
      props.setLoading(false);
    } catch (error) {
      message.error(`${t("General.error_during_upload")} ${error}`);
      props.setLoading(false);
    }
  };

  const handleDownload = () => {
    // Path to the CSV file in the public folder
    const filePath = '/import-voucher-template.csv';

    // Create a temporary anchor element
    const link = document.createElement('a');
    link.href = filePath;
    link.download = 'import-voucher-template.csv'; // File name for the download
    link.style.display = 'none'; // Hide the anchor element

    // Append the link to the body and trigger the click event
    document.body.appendChild(link);
    link.click();

    // Remove the temporary anchor element
    document.body.removeChild(link);
  };

  const btnList = [
    // {
    //   title: 'Are you sure to remove the selected Supplied Item(s)?',
    //   text: t("General.bulk_remove"),
    //   classes: 'red-btn text-white attendance-success',
    //   permit: true,
    //   notooltip: true,
    //   action: () => onBulkRemove()
    // },
    {
      text: t("Pos.import_vouchers"),
      classes: 'green-btn attendance-success',
      isUploadCsv: true,
      hidden: voucherItems?.total_count > 0 || data?.quantity > 0,
      action: (e) => handleUpload(e)
    },
    {
      text: t("General.download_template"),
      classes: 'attendance-success',
      // isUploadCsv: true,
      hidden: voucherItems?.total_count > 0 || data?.quantity > 0,
      action: (e) => handleDownload(e)
    },
  ];

  const onTableChange = (pagination, filters, sorter) => {
    setPage(pagination.current);
    setLimit(pagination.pageSize);
    if (sorter.order) {
      dispatch(getVoucherItems(pagination.current, pagination.pageSize, sorter.order, sorter.columnKey, searchVal, props.setLoading, id));
    } else {
      dispatch(getVoucherItems(pagination.current, pagination.pageSize, '', '', searchVal, props.setLoading, id));
    }
  }
  
  const onSearch = (search) => {
    setPage(1);
    if (search) {
      let searching = {};
      searching = {
        code: search?.code
      };
      setSearchVal(searching);
      dispatch(getVoucherItems(1, limit, '', '', searching, props.setLoading, id));
    } else {
      setSearchVal(null);
      dispatch(getVoucherItems(1, limit, '', '', null, props.setLoading, id));
    }
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const onRemove = async (prodId) => {
    setLoading(true);

    const payload = {
      voucher_id: id,
      voucher_item_id: prodId,
      status_event: 'remove'
    }

    await removeVoucherItem(payload).then(res => {
      setLoading(false);
      if (res.data.code === 200) {
        message.success(t("Success.remove_voucher_item"));
        setTimeout(() => dispatch(getVoucherItems(page, limit, '', '', searchVal, props.setLoading, id)), 500);
      }
    }).catch(e => {
      setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  }

  return (
    <>
      <Row gutter={[10, 10]}>
        <Col span={24}>
          <HeadingChip title={""} btnList={btnList} btnHidden={selectedRowKeys.length <= 0} />
        </Col>
        <Col span={24} className="">
          <ListCard
            onSearch={onSearch}
            Search={Search}
            ListData={voucherItems?.list?.map(x => ({ ...x, key: x.id }))}
            onChange={onTableChange}
            ListCol={colName}
            // rowSelection={rowSelection}
            pagination={{
              total: voucherItems?.total_count,
              current: page,
              pageSize: limit
            }}
          />
        </Col>
      </Row>
    </>
  )
}